var _defs, _path, _polygon, _circle, _circle2, _rect, _path2, _circle3, _circle4, _circle5, _circle6, _circle7;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Product_Icons",
    "data-name": "Product Icons",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-tag-1,.cls-tag-2{fill:#4285f4;}.cls-tag-1,.cls-tag-4{fill-rule:evenodd;}.cls-tag-3,.cls-tag-4{fill:#669df6;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon_24px_Color_ServiceDiscovery") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-tag-1",
    d: "M18.18,17.24a9,9,0,0,1-1.51,1.32l2.94,2.94a1,1,0,0,0,1.41,0h0a1,1,0,0,0,0-1.41Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-tag-2",
    points: "14 15.5 9.19 15.5 13.19 7.5 10 7.5 10 6.5 14.81 6.5 10.81 14.5 14 14.5 14 15.5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-tag-3",
    cx: 14,
    cy: 15,
    r: 1.25
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-tag-3",
    cx: 10,
    cy: 15,
    r: 1.25
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-tag-2",
    x: 8,
    y: 10.5,
    width: 8,
    height: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-tag-4",
    d: "M12,4a7,7,0,1,1-7,7,7,7,0,0,1,7-7m0-2a9,9,0,1,0,9,9,9,9,0,0,0-9-9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-tag-3",
    cx: 12,
    cy: 11,
    r: 1.25
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-tag-3",
    cx: 8,
    cy: 11,
    r: 1.25
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-tag-3",
    cx: 16,
    cy: 11,
    r: 1.25
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-tag-3",
    cx: 14,
    cy: 7,
    r: 1.25
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-tag-3",
    cx: 10,
    cy: 7,
    r: 1.25
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.0412e6e2d0369d93ab480400adca8da3.svg";
export { ForwardRef as ReactComponent };